
(function(template){
  define('vue!app/views/vue/components/packageDivComponent/packageSelectionComponent/userComponent',[
    "Vue",
    "helpers",
    "vuex",
    'vue!basicComponents/checkBox',
    'vue!./dummy'

  ], function (
    Vue,
    helpers,
    vuex,
    checkBox,
    dummy
  ) {
    return {
      template: template,
      name: "",
      props: ['userId', 'service', 'selected', 'isAllowedToSelect'],
      data: function () {
        return {}
      },
      computed: _.extend(
        vuex.mapState(['usersWithIds', 'listOfUsersWithService']), {}),
      components: {
        'check-box': checkBox,
        'dummy': dummy,

      },
      methods: {
        handleMultipleClick: function (userId, checked) {
          this.$emit('handleMultipleClick', userId, checked)
        },
        toggleShowMemberDropdown: function (bool) {
          this.$emit('toggleShowMemberDropdown', bool)
        }
      }
    }
  })
})('<div class="userDropdown" :class="isAllowedToSelect == false ?\'disable-service-selection-for-user\':\'\'"> <check-box :userId="userId" :selected="selected" @handle-Multiple-Click="handleMultipleClick" @toggle-ShowMember-Dropdown="toggleShowMemberDropdown"> </check-box> <span class="user_name">{{usersWithIds[userId]}}</span> <dummy v-bind:customerID="userId" v-bind:service="service" :selected="selected"></dummy> <p v-if="isAllowedToSelect == false"> {{localStrings.stepper.body.pick.service.details.alreadyHasService + \' \' + listOfUsersWithService[userId].serviceName}} </p> </div>');
